export default __webpack_public_path__ + "static/media/heart-72.1cf0322d.svg";